import { useEffect, useRef, useState } from "react";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { Grid2x2, LoaderCircle, Trash2, AlignJustify, FolderSync, FileOutput, CreditCard, CircleAlert, CalendarCog, PrinterCheck, Loader } from "lucide-react";
import { StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import InfiniteScroll from "react-infinite-scroll-component";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Snackbar } from "components";
import { ShimmerDepartmentRender, ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import appStore from "store/appStore";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";

import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { noneProfile, iconRemove } from "assets";

import SearchBarStaff from "components/app/search-bar/SearchBarStaff";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";

import { Sheet, SheetContent } from "components/ui/sheet";

import RequestAction from "./RequestAction";
import PageLeavRequest from "./dialog/dialogEmployeeLeaveRequest/PageLeavRequest";

import DatePickerInput from "components/app/function/DatePickerInput";
import { useLocation } from "react-router-dom";
import useUrlString from "./useUrlString";
import { Service } from "utils/services";

export default function Request() {
  const location = useLocation();
  const { handleClickUrl, hanleClickRemoveURl } = useUrlString();
  const [isDetail, setIsDetail] = useState<boolean>(false);

  const dataEmployeeRequest = RequestAction();

  //--------------------------staff----------------------
  const { showDialogConfirm } = appStore();
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);
  const [editItemCategories, setEditItemCategories] = useState<any>(null);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [hovered, setHovered] = useState(false);
  const handleClickCategory = ({ categoryName }: { categoryName: string }) => {
    if (selectedProductGroupCode === categoryName) return;
    setSelectedProductGroupCode(categoryName);
    selectedProductGroupCodeRef.current = categoryName;
  };
  const [view, setView] = useState("card");
  const listRef = useRef<any>(null);
  const { btnToggle } = useAppSelector((state) => state.header);

  useEffect(() => {
    const savedView = localStorage.getItem("leaveRequest-display-layout");
    if (savedView) {
      setView(savedView);
    }
  }, [dataEmployeeRequest?.searchTextInput, selectedProductGroupCode]);

  //---------------------submit Create and Update staffs--------------------

  const dispatch = useDispatch();
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("leaveRequest-display-layout", selectedView);
  };

  const allIds = Array.isArray(dataEmployeeRequest?.employeeInitRequestSearch?.data) ? dataEmployeeRequest?.employeeInitRequestSearch?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedProductIds([]);
    } else {
      setSelectedProductIds(allIds);
    }
  };

  const handleClick = (title: string) => {
    // setLoading(true);
    if (title === "Leave Application Form") {
      dataEmployeeRequest?.setOpenPopoverIndex(1);
      dataEmployeeRequest.getShopEmployeeInitRequest("Leave Application Form");
      // setLoading(false);
    } else if (title === "Tardiness Application Form") {
      dataEmployeeRequest?.setOpenPopoverIndex(1);
      dataEmployeeRequest.getShopEmployeeInitRequest("Tardiness Application Form");
      // setLoading(false);
    } else if (title === "Change DO Application Form") {
      dataEmployeeRequest?.setOpenPopoverIndex(1);
      dataEmployeeRequest.getShopEmployeeInitRequest("Change DO Application Form");
      // setLoading(false);
    } else if (title === "Change Shift Application Form") {
      dataEmployeeRequest?.setOpenPopoverIndex(1);
      dataEmployeeRequest.getShopEmployeeInitRequest("Change Shift Application Form");
      // setLoading(false);
    } else {
      Snackbar({
        message: "Coming soon",
        status: StatusMsg.warning,
      });
    }
  };
  const requestOption = [
    {
      id: 1,
      title: "Leave Application Form",
      label: "Please fill out the details of your leave request.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          {/* <FileOutput /> */}
          <i className="fa-solid fa-person-walking-arrow-right fa-flip-horizontal"></i>
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm dark:text-white">Configure employee work schedules, shifts, and availability across days or weeks.</p>
          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
            <li>Assign shifts to employees based on roles, departments, or availability.</li>
            <li>Customize working hours, break times, and rotation patterns.</li>
            <li>Ensure proper staffing coverage and reduce scheduling conflicts.</li>
            <li>Essential for accurate timesheets and payroll calculations.</li>
          </ul>
        </>,
      ],
    },

    {
      id: 2,
      title: "Tardiness Application Form",
      label: "Fill out this form to document your late attendance.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white p-2 rounded-full">
          <i className="fa-solid fa-arrow-up-wide-short"></i>
        </div>
      ),
      description: [],
    },
    {
      id: 3,
      title: "Change DO Application Form",
      label: "Submit your request to modify your regular day off schedule.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-cyan-500 text-white p-2 rounded-full">
          <CalendarCog />
        </div>
      ),
      description: [],
    },
    {
      id: 4,
      title: "Change Shift Application Form",
      label: "Request to modify assigned work shift schedule.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-pink-500 text-white p-2 rounded-full">
          <FolderSync />
        </div>
      ),
    },
  ];

  //   ----------------------fetch type request---------------------
  useEffect(() => {
    dataEmployeeRequest?.getShopEmployeeRequestType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (listRef.current && dataEmployeeRequest?.employeeRequestSearchLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      dataEmployeeRequest?.fetchMoreEmployeeRequestSearch({
        next: dataEmployeeRequest?.employeeRequestSearchLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEmployeeRequest?.employeeInitRequestSearch?.data, dataEmployeeRequest?.searchTextInput, dataEmployeeRequest?.dobRequest]);

  useEffect(() => {
    dataEmployeeRequest?.getShopEmployeeRequestSearch(editItemCategories);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEmployeeRequest?.searchTextInput, selectedProductGroupCode, dataEmployeeRequest?.dobRequest, dataEmployeeRequest?.btnToggle]);
  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("request_id");
    if (requestId) {
      (async () => {
        await dataEmployeeRequest?.getShopEmployeeRequestDetail(requestId);
        dataEmployeeRequest?.setWarning2(false);
      })();
    }
  }, []);

  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white  dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="text-start lg:w-auto md:w-auto  w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Request</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Smart Scheduling, Attendance, and Performance Tracking</p>
          </div>
          {dataEmployeeRequest?.warning ? (
            ""
          ) : (
            <nav className="border-gray-200 pt-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                {selectProducts && (
                  <div className="flex items-center justify-center px-5 py-2 bg-blue-500 rounded-full text-white">
                    Employee Selected {selectedProductIds.length} / {allIds.length}
                  </div>
                )}
                <>
                  {!selectProducts ? (
                    <>
                      <Popover>
                        <PopoverTrigger asChild>
                          <label className=" font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300">
                            <AlignJustify />
                          </label>
                        </PopoverTrigger>
                        <PopoverContent className="w-80 relative">
                          {requestOption?.map((item: any, index: number) => {
                            return (
                              <HoverCardDetail key={index} title={item.title} description={item.description}>
                                <div
                                  key={index}
                                  className="gap-3 group  flex items-center px-3 py-2 rounded-md hover:bg-accent cursor-pointer"
                                  onClick={() => {
                                    handleClick(item.title);
                                    setIsDetail(false);
                                    dataEmployeeRequest?.setWarning2(false);
                                  }}
                                >
                                  <span className="group-hover:scale-110 transition-all duration-300">{item.icon}</span>

                                  <div className="flex flex-col ">
                                    <span className="font-medium leading-none lg:text-md md:text-sm text-[13px]">{item.title}</span>
                                    <span className="text-sm text-muted-foreground line-clamp-1">{item.label} </span>
                                  </div>
                                </div>
                              </HoverCardDetail>
                            );
                          })}
                        </PopoverContent>
                      </Popover>
                    </>
                  ) : (
                    <>
                      {selectedProductIds.length > 0 && !btnToggle ? (
                        <>
                          <HoverCardDetail
                            title="Delete Staff "
                            description={
                              <>
                                <p className="mb-2 font-medium text-sm dark:text-white">
                                  Move the staff record to Trash. The employee will no longer appear in active lists but can be recovered.
                                </p>
                                <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                  <li>Soft delete allows for accidental removals to be undone.</li>
                                  <li>Trash keeps records safe until permanent deletion.</li>
                                  <li>Useful for managing staff turnover or temporary removals.</li>
                                </ul>
                              </>
                            }
                          >
                            <label
                              onClick={() =>
                                showDialogConfirm({
                                  titileButtonSubmit: "Yes, Delete",
                                  titileButtonCancel: "No, Cancel",
                                  title: "Delete",
                                  message: "Do you want to delete?",
                                  onSubmit() {
                                    // submitDeleteShopEmployee();
                                  },
                                })
                              }
                              className="group transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                            >
                              <Trash2 className=" transition-colors duration-300" />
                            </label>
                          </HoverCardDetail>
                        </>
                      ) : (
                        btnToggle && (
                          <>
                            <HoverCardDetail
                              title="Restore Staff "
                              description={
                                <>
                                  <p className="mb-2 font-medium text-sm dark:text-white ">Restore an staff record from Trash back to the active staff list.</p>
                                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                    <li>Recovers all staff details and permissions.</li>
                                    <li>Useful if deletion was accidental or temporary.</li>
                                    <li>Immediately makes the staff visible in all relevant areas.</li>
                                  </ul>
                                </>
                              }
                            >
                              <label
                                onClick={() =>
                                  showDialogConfirm({
                                    titileButtonCancel: "No, Cancel",
                                    title: "Recover",
                                    message: "Do you want to recover?",
                                    onSubmit() {
                                      // submitUndoDeleteShopEmployee();
                                    },
                                  })
                                }
                                className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                              >
                                <i className="fa-solid fa-trash-can-arrow-up text-xl   transition-colors duration-300"></i>
                              </label>
                            </HoverCardDetail>
                            <HoverCardDetail
                              title="Permanently Deleted"
                              description={
                                <>
                                  <p className="mb-2 font-medium text-sm dark:text-white ">Permanently delete the staff record from the system. This action cannot be undone.</p>
                                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                    <li>Removes all data associated with the staff.</li>
                                    <li>The staff will no longer be available in any reports or listings.</li>
                                    <li>Make sure the staff is no longer required before deleting permanently.</li>
                                  </ul>
                                  {/* <p className="text-xs text-red-500 mt-1">⚠️ This is irreversible.</p> */}
                                </>
                              }
                            >
                              <label
                                onClick={() =>
                                  showDialogConfirm({
                                    titileButtonCancel: "No, Cancel",
                                    title: "Permanance Delete",
                                    message: "Do you want to permanance delete?",
                                    onSubmit() {
                                      // submitDeleteShopEmployee();
                                    },
                                  })
                                }
                                className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                              >
                                <img
                                  src={iconRemove}
                                  className="w-7 h-7 transition duration-300 filter  group-hover:hue-rotate-[330deg] group-hover:saturate-[5] dark:invert"
                                  alt="icon"
                                />
                              </label>
                            </HoverCardDetail>
                          </>
                        )
                      )}
                    </>
                  )}
                </>

                {dataEmployeeRequest?.loadingPrint ? (
                  <label
                    htmlFor=""
                    className="hover:border-3 hover:scale-110 transition-all  duration-300  font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                  >
                    <Loader className="animate-spin" />
                  </label>
                ) : (
                  <HoverCardDetail
                    title="Daily Attendance Detail Report"
                    description={
                      <>
                        <p className="mb-2 font-medium text-sm text-gray-800">View and analyze detailed attendance records for each employee on a daily basis.</p>
                        <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                          <li>Monitor clock-in/out times, absences, and late entries.</li>
                          <li>Track working hours, overtime, and shift compliance.</li>
                          <li>Export reports for HR reviews or payroll processing.</li>
                          <li>Identify patterns for attendance-related issues.</li>
                        </ul>
                      </>
                    }
                  >
                    <label
                      onClick={() => {
                        dataEmployeeRequest?.handlePrint(editItemCategories);
                      }}
                      htmlFor=""
                      className="hover:border-3 hover:scale-110 transition-all  duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                    >
                      <PrinterCheck />
                    </label>
                  </HoverCardDetail>
                )}
              </div>

              <div className="flex items-center gap-2 ms-5 ">
                <DatePickerInput
                  placeholder="Pick a date"
                  className="py-4 h-[45px] border border-gray-300 "
                  onChange={(value) => {
                    dataEmployeeRequest?.setDobRequest(value);
                  }}
                  value={dataEmployeeRequest?.dobRequest}
                />
              </div>
              {/* Search & View Switch */}
              <div className="flex items-center gap-2">
                <div className="flex-1 ms-4 me-2">
                  <div className="relative">
                    <SearchBarStaff
                      onValueChange={(value) => {
                        dataEmployeeRequest?.setSearchTextInput(value);
                      }}
                    />
                  </div>
                </div>

                {/* View Toggle Button */}
                <HoverCardDetail
                  title="Reset"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">Switch between different layouts to view staff records in the format you prefer.</p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>
                          <strong>Card View:</strong> Shows each staff as an individual card with profile info and actions.
                        </li>
                        <li>
                          <strong>Table View:</strong> Displays staff in a structured table for sorting, scanning, and bulk actions.
                        </li>
                        <li>Use the layout that best suits your workflow or screen size.</li>
                      </ul>
                    </>
                  }
                >
                  <div className="relative">
                    {view === "card" ? (
                      <button
                        onClick={() => changeView("table")}
                        className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <Grid2x2 className="font-semibold size-5" />
                      </button>
                    ) : (
                      <button
                        onClick={() => changeView("card")}
                        className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        {/* <WalletCards  /> */}
                        <CreditCard className="text-xl" />
                      </button>
                    )}
                  </div>
                </HoverCardDetail>
              </div>
            </nav>
          )}
        </div>
        {/* scrollCategories */}
        {dataEmployeeRequest?.warning ? (
          ""
        ) : (
          <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
          >
            {/* Hover Overflow Scroll Container */}
            <div className="relative w-full ">
              <div className="flex space-x-2 w-full">
                {/* Add Category */}

                {/* "All" Category */}
                <div
                  onClick={() => {
                    setEditItemCategories("");

                    if (selectedProductGroupCode === "All") {
                      setEditItemCategories("");
                    }
                    handleClickCategory({
                      categoryName: "",
                    });
                  }}
                  className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                    selectedProductGroupCode === "" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
                  }`}
                >
                  <span className="lg:text-sm md:text-sm text-[12px]">All</span>
                </div>
                {/* Product Categories */}
                <div className="space-x-2 flex ">
                  {dataEmployeeRequest?.loadingGetShopEmployeeRequestType ? (
                    <>
                      <ShimmerDepartmentRender />
                    </>
                  ) : (
                    <>
                      {dataEmployeeRequest?.mergedRequestTypes?.map((group: any, index: any) => (
                        <div key={index} className="flex items-center relative z-1 ">
                          <div
                            className={`absolute z-10 top-0 right-0 text-white px-2 rounded-bl-md rounded-tr-md mt-0 ${
                              group.request_type === "Change DO Application Form"
                                ? " bg-cyan-500"
                                : group.request_type === "Change Shift Application Form"
                                ? " bg-pink-500"
                                : group.request_type === "Leave Application Form"
                                ? "bg-green-500"
                                : "bg-blue-500"
                            }`}
                          >
                            <span className="text-sm font-bold">{group.no_of_pending > 0 ? group.no_of_pending : ""}</span>
                          </div>

                          {group.request_type && (
                            <div
                              className={`flex items-center px-5 w-auto whitespace-nowrap lg:h-14 md:h-12 h-10 border rounded-md cursor-pointer font-semibold ${
                                selectedProductGroupCode === group.request_type ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200" : "dark:hover:bg-slate-900"
                              }`}
                              onClick={() => {
                                setEditItemCategories(group.request_type);
                                handleClickCategory({ categoryName: group.request_type });
                              }}
                            >
                              <div className="flex group">
                                <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden flex items-center justify-center">{group.request_type}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {dataEmployeeRequest?.warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              dataEmployeeRequest?.errorStatus?.title === "success" || dataEmployeeRequest?.errorStatus?.title === "info"
                ? "text-green-500"
                : dataEmployeeRequest?.errorStatus?.title === "warning"
                ? "text-yellow-500"
                : "text-red-500"
            }`}
          >
            {dataEmployeeRequest?.errorStatus?.title === "success"
              ? "Success"
              : dataEmployeeRequest?.errorStatus?.title === "info"
              ? "Infomation"
              : dataEmployeeRequest?.errorStatus?.title === "warning"
              ? "Warning"
              : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{dataEmployeeRequest?.errorStatus?.message}</span>
        </div>
      ) : (
        <div className="pb-3 h-full mt-5 ">
          {view === "card" ? (
            <>
              {dataEmployeeRequest?.loadingEmployeeInitRequestSearch ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <InfiniteScroll
                  dataLength={dataEmployeeRequest?.employeeInitRequestSearch?.data?.length || 0}
                  next={() =>
                    dataEmployeeRequest?.fetchMoreEmployeeRequestSearch({
                      next: dataEmployeeRequest?.employeeRequestSearchLoading.nextPageUrl,
                    })
                  }
                  hasMore={!!dataEmployeeRequest?.employeeRequestSearchLoading?.nextPageUrl}
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    <div ref={listRef} className={`grid grid-cols-2 md:grid-cols-5 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"} gap-y-3 gap-x-2 mb-10 `}>
                      {dataEmployeeRequest?.employeeInitRequestSearch?.data
                        ?.filter((item: any, index: number, self: any) => index === self.findIndex((t: any) => t.id === item.id))
                        ?.map((item: any, index: number) => {
                          return (
                            <div
                              onClick={() => {
                                if (selectProducts) {
                                  setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                  return;
                                } else {
                                  if (item.is_deleted === 0) {
                                    dataEmployeeRequest?.getShopEmployeeRequestDetail(item.id);
                                    setIsDetail(true);
                                    dataEmployeeRequest?.setWarning2(false);
                                    handleClickUrl(item?.id, "request_id");
                                  }
                                }
                              }}
                              key={index}
                              className={`group cursor-pointer relative z-1 w-full max-w-sm border rounded-lg  ${selectedProductIds.includes(item.id) ? " " : ""}`}
                            >
                              {item.is_deleted !== 1 && (
                                <div
                                  className={`absolute z-10 top-0 right-0 ${
                                    item?.status === "Pending" ? "bg-yellow-500" : item?.status === "Approved" ? "bg-green-500" : "bg-red-500"
                                  }  text-white px-2 py-1 rounded-bl-md rounded-tr-md mt-0`}
                                >
                                  <span className="text-sm font-bold ">{item?.status}</span>
                                </div>
                              )}
                              <div className=" w-full relative overflow-hidden aspect-square  ">
                                <ImageUrl
                                  className={`rounded-t-md w-full h-full  object-cover   ${item.is_deleted === 1 && "opacity-50"} `}
                                  src={!item.requester?.picture ? noneProfile : item.requester?.picture}
                                  alt=""
                                />

                                <div
                                  className={`${
                                    selectedProductIds.includes(item.id) ? "bg-white" : ""
                                  } w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                                >
                                  {selectedProductIds.includes(item.id) ? (
                                    <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                  ) : (
                                    <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                  )}
                                </div>
                                {selectProducts === true && <div className="absolute inset-0 mx-auto top-[50%] z-50  w-8 h-8  text-white  rounded-full p-1"></div>}
                                {item.is_deleted === 0 ? (
                                  ""
                                ) : (
                                  <button
                                    onClick={(event) => {
                                      event.stopPropagation();
                                    }}
                                    className=" font-semibold absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[50%] cursor-pointer w-[80px] h-8 bg-black/50 rounded-full p-1"
                                  >
                                    Deleted
                                  </button>
                                )}
                              </div>
                              <div className={`p-4  `}>
                                <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.requester?.local_name}</h5>
                                <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.requester?.department}</span>
                                <div key={index} className="flex flex-col items-start mt-2 w-full">
                                  <div className="flex w-full ">
                                    {item.request_type === "Leave Application Form" && (
                                      <p className={`font-bold text-[15px] my-1 w-full  rounded-md py-1  line-clamp-1 text-green-500`}>{item.document?.leave_type}</p>
                                    )}
                                    {item.request_type === "Tardiness Application Form" && (
                                      <p className={`font-bold text-[15px] my-1 w-full  rounded-md py-1  line-clamp-1 text-blue-500`}>Tardiness</p>
                                    )}
                                    {item.request_type === "Change Shift Application Form" && (
                                      <p className={`font-bold text-[15px] my-1 w-full  rounded-md py-1  line-clamp-1 text-pink-500`}>Change Shift</p>
                                    )}
                                    {item.request_type === "Change DO Application Form" && (
                                      <p className={`font-bold text-[15px] my-1 w-full  rounded-md py-1  line-clamp-1  text-cyan-500`}>Change Day Off</p>
                                    )}
                                  </div>

                                  {item.request_type === "Leave Application Form" ? (
                                    <div key={index} className="flex justify-between w-full ">
                                      <p className="text-md  ">
                                        {(() => {
                                          const date = new Date(item?.document?.starting_date);
                                          const day = date.getDate();
                                          const weekday = date.toLocaleDateString("en-GB", {
                                            weekday: "short",
                                          });
                                          const month = date.toLocaleDateString("en-GB", {
                                            month: "short",
                                          });

                                          const year = date.getFullYear();
                                          return `${weekday}, ${day}-${month}-${year}`;
                                        })()}
                                      </p>
                                      <p className={` font-bold text-[15px] text-red-500 `}>
                                        {item.document?.leave_period === "Full Day"
                                          ? `${parseFloat(item.document?.no_of_day) + "d"}`
                                          : `${parseFloat(item.document?.no_of_hour) + "h"}`}
                                      </p>
                                    </div>
                                  ) : (
                                    <div key={index} className="flex justify-between w-full ">
                                      <p className="text-md  ">
                                        {(() => {
                                          const date = new Date(item?.document?.working_date);
                                          const day = date.getDate();
                                          const weekday = date.toLocaleDateString("en-GB", {
                                            weekday: "short",
                                          });
                                          const month = date.toLocaleDateString("en-GB", {
                                            month: "short",
                                          });

                                          const year = date.getFullYear();
                                          return `${weekday}, ${day}-${month}-${year}`;
                                        })()}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      {!dataEmployeeRequest?.employeeInitRequestSearch?.next_page_url ? (
                        <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                          <b>Nothing more to load!</b>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                </InfiniteScroll>
              )}
            </>
          ) : (
            <>
              {dataEmployeeRequest?.employeeInitRequestSearch ? (
                <InfiniteScroll
                  dataLength={dataEmployeeRequest?.employeeInitRequestSearch?.data?.length || 0}
                  next={() =>
                    dataEmployeeRequest?.fetchMoreEmployeeRequestSearch({
                      next: dataEmployeeRequest?.employeeRequestSearchLoading?.nextPageUrl,
                    })
                  }
                  scrollThreshold="90%"
                  hasMore={!!dataEmployeeRequest?.employeeRequestSearchLoading?.nextPageUrl}
                  scrollableTarget="scrollableDiv"
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    {dataEmployeeRequest?.loadingEmployeeInitRequestSearch ? (
                      <SkeletonMusicLibrariesTable />
                    ) : (
                      <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
                        <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
                          <tr className="border-none  text-[15px]">
                            <th className="py-5 text-start  px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                            <th className=" px-4 text-start ">Staff Info. </th>
                            <th className="text-start  pe-[70px] ps-4">Status</th>
                            <th className="text-start px-4">Contact</th>

                            <th className="text-start  px-4">Department</th>
                            <th className="text-start  px-4">Request </th>
                            <th className="text-start  pe-[70px] "> Date</th>
                            <th className="text-start  px-4"> Approvers</th>
                            <th className="text-start  px-4"> Status</th>
                          </tr>
                        </thead>
                        <tbody ref={listRef}>
                          {dataEmployeeRequest?.employeeInitRequestSearch?.data
                            ?.filter((item: any, index: number, self: any) => index === self.findIndex((t: any) => t.id === item.id))
                            ?.map((item: any, index: number) => {
                              return (
                                <tr
                                  onClick={() => {
                                    if (selectProducts) {
                                      setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                      return;
                                    } else {
                                      if (item.is_deleted === 0) {
                                        setIsDetail(true);
                                        dataEmployeeRequest?.getShopEmployeeRequestDetail(item.id);
                                        dataEmployeeRequest?.setWarning2(false);
                                        handleClickUrl(item?.id, "request_id");
                                      }
                                    }
                                  }}
                                  key={index}
                                  className={`group text-center cursor-pointer ${
                                    index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "
                                  } hover:bg-gray-300`}
                                >
                                  <td className="relative w-[120px] h-[120px] aspect-square overflow-hidden ">
                                    {item.is_deleted === 0 ? (
                                      ""
                                    ) : (
                                      <button
                                        onClick={(event) => {
                                          event.stopPropagation();
                                        }}
                                        className="font-semibold text-sm z-50 absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[40%] cursor-pointer w-[70px] h-8 bg-black/50 rounded-full p-1"
                                      >
                                        Deleted
                                      </button>
                                    )}
                                    <img
                                      className={`w-full  z-1 mx-auto relative h-full ${item.is_deleted === 1 && "opacity-50"}  `}
                                      src={!item.requester?.picture ? noneProfile : item.requester?.picture}
                                      alt=""
                                    />
                                  </td>
                                  <td className="py-2 px-4 text-md  text-left align-top">
                                    <p className="text-[15px] font-bold ">{item.requester?.card_no}</p>

                                    <p className="text-[15px] ">{item.requester?.local_name}</p>
                                    <p className="text-md text-muted-foreground ">{item.requester?.english_name}</p>
                                    <p className="text-md text-muted-foreground ">{item?.requester?.nationality}</p>
                                  </td>
                                  <td className="py-2 px-4  text-md  text-left align-top text-nowrap">
                                    <p className="text-md "> {item?.requester?.gender}</p>
                                    <p className="text-md text-muted-foreground"> {item?.requester?.marital_status}</p>
                                    <p className="text-md flex items-center  gap-2  text-muted-foreground text-nowrap">
                                      {(() => {
                                        const date = new Date(item.requester?.date_of_birth);
                                        const day = date.getDate();
                                        const weekday = date.toLocaleDateString("en-GB", {
                                          weekday: "short",
                                        });
                                        const month = date.toLocaleDateString("en-GB", {
                                          month: "short",
                                        });

                                        const year = date.getFullYear();
                                        return `${weekday}, ${day}-${month}-${year}`;
                                      })()}
                                    </p>
                                  </td>
                                  <td className="py-2 px-4 text-md  text-left align-top">
                                    <p className="text-md "> {item?.requester?.phone_no}</p>
                                    <p className="text-md line-clamp-1 text-muted-foreground"> {item?.requester?.email}</p>
                                    <p className="text-md text-muted-foreground">{item?.requester?.address}</p>
                                  </td>

                                  <td className="py-2 px-4 text-md  text-left align-top">
                                    <p className="text-md line-clamp-1 "> {item?.department}</p>
                                    <p className="text-md text-muted-foreground "> {item?.position}</p>
                                  </td>
                                  <td className="py-2 px-4  text-left align-top h-[100px] overflow-hidden ">
                                    {/* --------Leave Application Form------ */}
                                    {item.request_type === "Leave Application Form" && (
                                      <>
                                        <p className={`font-bold text-[15px] w-full  rounded-md py-1  line-clamp-1 text-green-500`}>{item.document?.leave_type}</p>

                                        <p className="text-[15px] font-bold text-red-500">
                                          {" "}
                                          {item.document?.leave_period === "Full Day"
                                            ? `${parseFloat(item.document?.no_of_day)} ${parseFloat(item.document?.no_of_day) === 1 ? "Day" : "Days"}`
                                            : `${parseFloat(item.document?.no_of_hour)} ${parseFloat(item.document?.no_of_hour) === 1 ? "Hour" : "Hours"}`}
                                        </p>
                                      </>
                                    )}
                                    {/* --------Tardiness Application Form------ */}

                                    {item.request_type === "Tardiness Application Form" && (
                                      <>
                                        <p className={`font-bold text-[15px] w-full  rounded-md py-1  line-clamp-1 text-blue-500`}>Tardiness</p>

                                        {item.document?.missing_type === "Other" ? (
                                          <p
                                            className="text-md text-muted-foreground line-clamp-3"
                                            dangerouslySetInnerHTML={{
                                              __html: item.document?.missing_remark?.replace(/\n/g, "<br />"),
                                            }}
                                          ></p>
                                        ) : (
                                          <p className="text-md text-muted-foreground">{item.document?.missing_type}</p>
                                        )}
                                      </>
                                    )}
                                    {/* --------Chnage Day Off------ */}

                                    {item.request_type === "Change DO Application Form" && (
                                      <>
                                        <p className={`font-bold text-[15px] w-full  rounded-md py-1  line-clamp-1 text-cyan-500`}>Change Day Off</p>
                                        <p
                                          className="text-md text-muted-foreground line-clamp-3"
                                          dangerouslySetInnerHTML={{
                                            __html: item.document?.remark?.replace(/\n/g, "<br />"),
                                          }}
                                        ></p>
                                      </>
                                    )}
                                    {/* --------Leave Application Form------ */}
                                    {item.request_type === "Change Shift Application Form" && (
                                      <>
                                        <p className={`font-bold text-[15px] w-full  rounded-md py-1  line-clamp-1 text-pink-500`}>Change Shift</p>
                                        <p
                                          className="text-md text-muted-foreground line-clamp-3 overflow-hidden"
                                          dangerouslySetInnerHTML={{
                                            __html: item.document?.remark?.replace(/\n/g, "<br />"),
                                          }}
                                        ></p>
                                      </>
                                    )}
                                  </td>

                                  <td className="py-2 text-md  text-left align-top text-nowrap">
                                    {/* --------Leave Application Form------ */}
                                    {item.request_type === "Leave Application Form" && (
                                      <>
                                        <p className="text-md font-bold  ">
                                          {(() => {
                                            const date = new Date(item?.document?.starting_date);
                                            const day = date.getDate();
                                            const weekday = date.toLocaleDateString("en-GB", {
                                              weekday: "short",
                                            });
                                            const month = date.toLocaleDateString("en-GB", {
                                              month: "short",
                                            });

                                            const year = date.getFullYear();
                                            return `${weekday}, ${day}-${month}-${year}`;
                                          })()}
                                        </p>
                                        <p className="text-md text-muted-foreground pt-1">
                                          {item.document?.leave_period === "Full Day" ? (
                                            <>
                                              {item.document?.no_of_day > 1 && (
                                                <>
                                                  {(() => {
                                                    const date = new Date(item.document?.ending_date);
                                                    const day = date.getDate();
                                                    const weekday = date.toLocaleDateString("en-GB", {
                                                      weekday: "short",
                                                    });
                                                    const month = date.toLocaleDateString("en-GB", {
                                                      month: "short",
                                                    });

                                                    const year = date.getFullYear();
                                                    return `${weekday}, ${day}-${month}-${year}`;
                                                  })()}
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <div className="flex items-center gap-1 text-muted-foreground">
                                              <p className="text-md text-nowrap"> {Service.formatTime(item.document?.starting_time)}</p>-
                                              <p className="text-md text-nowrap"> {Service.formatTime(item.document?.ending_time)}</p>
                                            </div>
                                          )}
                                        </p>
                                      </>
                                    )}
                                    {/* --------Tardiness Application Form------ */}

                                    {item.request_type === "Tardiness Application Form" && (
                                      <>
                                        <p className="text-md font-bold ">
                                          {(() => {
                                            const date = new Date(item?.document?.working_date);
                                            const day = date.getDate();
                                            const weekday = date.toLocaleDateString("en-GB", {
                                              weekday: "short",
                                            });
                                            const month = date.toLocaleDateString("en-GB", {
                                              month: "short",
                                            });

                                            const year = date.getFullYear();
                                            return `${weekday}, ${day}-${month}-${year}`;
                                          })()}
                                        </p>
                                        <p className="text-md text-muted-foreground">
                                          {item.document?.missing_period
                                            ?.split("|")
                                            .map((s: any) => s.trim())
                                            .join(", ")}
                                        </p>
                                      </>
                                    )}

                                    {/* --------Chnage Day Off------ */}

                                    {item.request_type === "Change DO Application Form" && (
                                      <>
                                        <p className="text-md font-bold  ">
                                          {(() => {
                                            const date = new Date(item?.document?.working_date);
                                            const day = date.getDate();
                                            const weekday = date.toLocaleDateString("en-GB", {
                                              weekday: "short",
                                            });
                                            const month = date.toLocaleDateString("en-GB", {
                                              month: "short",
                                            });

                                            const year = date.getFullYear();
                                            return `${weekday}, ${day}-${month}-${year}`;
                                          })()}
                                        </p>
                                      </>
                                    )}
                                    {/* --------Change Shift Application Form------ */}

                                    {item.request_type === "Change Shift Application Form" && (
                                      <>
                                        <p className="text-md  font-bold">
                                          {(() => {
                                            const date = new Date(item?.document?.working_date);
                                            const day = date.getDate();
                                            const weekday = date.toLocaleDateString("en-GB", {
                                              weekday: "short",
                                            });
                                            const month = date.toLocaleDateString("en-GB", {
                                              month: "short",
                                            });

                                            const year = date.getFullYear();
                                            return `${weekday}, ${day}-${month}-${year}`;
                                          })()}
                                        </p>
                                        <p className="text-md text-muted-foreground">{item.document?.to_shift_group?.local_description}</p>
                                      </>
                                    )}
                                  </td>
                                  <td className=" text-left align-top ">
                                    {item?.approvers.map((approvers: any, index: number) => {
                                      return (
                                        <div key={index} className="gap-3 flex items-center  rounded-md p-1  w-[180px] ">
                                          <ImageUrl
                                            src={!approvers?.accept_employee?.picture ? noneProfile : approvers?.accept_employee?.picture}
                                            className=" h-[45px] w-[45px] rounded-full"
                                            alt={approvers?.accept_employee?.picture}
                                          />
                                          <div className="flex flex-col text-start ">
                                            <span className="w-full font-medium line-clamp-1 leading-none lg:text-md md:text-sm text-[15px]">
                                              {approvers?.accept_employee?.local_name?.length > 12
                                                ? `${approvers?.accept_employee?.local_name.slice(0, 12)}...`
                                                : approvers?.accept_employee?.local_name}
                                            </span>
                                            <span className="text-sm text-muted-foreground line-clamp-1">
                                              {approvers?.accept_employee?.position?.length > 12
                                                ? `${approvers?.accept_employee?.position.slice(0, 12)}...`
                                                : approvers?.accept_employee?.position}
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </td>
                                  <td className="py-2 px-4 text-md  text-left align-top">
                                    <div
                                      className={` ${
                                        item?.status === "Pending" ? "bg-yellow-500" : item?.status === "Approved" ? "bg-green-500" : "bg-red-500"
                                      }  text-white px-3 py-1 rounded-md mt-0 text-center inline-block`}
                                    >
                                      <span className=" text-sm font-bold ">{item?.status}</span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          {!dataEmployeeRequest?.employeeInitRequestSearch?.next_page_url ? (
                            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                              <b>Nothing more to load!</b>
                            </p>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </table>
                    )}
                  </>
                </InfiniteScroll>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      )}
      <Sheet
        open={dataEmployeeRequest?.openPopoverIndex === 1}
        onOpenChange={(isOpen) => {
          dataEmployeeRequest?.setOpenPopoverIndex(isOpen ? 1 : null);
          if (!isOpen) {
            hanleClickRemoveURl("request_id");
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1200px] justify-between p-3 pt-[50px]">
          <PageLeavRequest
            warning2={dataEmployeeRequest?.warning2}
            isDetail={isDetail}
            setOpenPopoverIndex={dataEmployeeRequest?.setOpenPopoverIndex}
            employeeInitRequest={dataEmployeeRequest.employeeInitRequest}
            loadingSubmitEmployeeInitRequest={dataEmployeeRequest?.loadingSubmitEmployeeInitRequest}
            formData={dataEmployeeRequest?.formData}
            setFormData={dataEmployeeRequest?.setFormData}
            formData2={dataEmployeeRequest?.formData2}
            setFormData2={dataEmployeeRequest?.setFormData2}
            formData3={dataEmployeeRequest?.formData3}
            setFormData4={dataEmployeeRequest?.setFormData4}
            formData4={dataEmployeeRequest?.formData4}
            setFormData3={dataEmployeeRequest?.setFormData3}
            handleSave={dataEmployeeRequest?.handleSave}
            handleSave2={dataEmployeeRequest?.handleSave2}
            handleSave3={dataEmployeeRequest?.handleSave3}
            handleSave4={dataEmployeeRequest?.handleSave4}
            loadingEmployeeInitRequestSearchDatail={dataEmployeeRequest?.loadingEmployeeInitRequestSearchDatail}
            setEmployeeInitRequest={dataEmployeeRequest?.setEmployeeInitRequest}
            getShopEmployeeRequestCommittee={dataEmployeeRequest?.getShopEmployeeRequestCommittee}
            shopEmployeeRequestCommittee={dataEmployeeRequest?.shopEmployeeRequestCommittee}
            setShopEmployeeRequestCommittee={dataEmployeeRequest?.setShopEmployeeRequestCommittee}
            handleAddApprover={dataEmployeeRequest?.handleAddApprover}
            handleScrollCommittee={dataEmployeeRequest?.handleScrollCommittee}
            fetchMoreDataCommittee={dataEmployeeRequest?.fetchMoreDataCommittee}
            scrollContainerRef={dataEmployeeRequest?.scrollContainerRef}
            warning={dataEmployeeRequest?.warning}
            errorStatus={dataEmployeeRequest?.errorStatus}
            isAddApproverLoading={dataEmployeeRequest?.isAddApproverLoading}
            submitShopEmployeeRequestUpdateStatus={dataEmployeeRequest?.submitShopEmployeeRequestUpdateStatus}
            submitShopEmployeeRequestUpdateStatusLoading={dataEmployeeRequest?.submitShopEmployeeRequestUpdateStatusLoading}
          />
        </SheetContent>
      </Sheet>
    </BusinessSuiteContentLayout>
  );
}
